module.exports = __webpack_public_path__ + "img/new_c.fff82e29.svg";